export const UploadWidgetAgidConfigSchema = {};
